<template>
  <span class="indicator-container">
    <span class="indicator" v-bind:class="indicatorClass"></span>
    <span v-if="showText" class="indicator text">{{ indicatorText }}</span>
  </span>
</template>

<script>
export default {
  props: {
    enable: {
      type: Boolean,
      default: false
    },
    na: {
      default: true
    },
    showText: {
      default: false
    },
    textForEnable: {
      type: String,
      default: 'Enable'
    },
    textForDisable: {
      type: String,
      default: 'Disable'
    },
    textForNa: {
      type: String,
      default: 'N/A'
    }
  },
  computed: {
    indicatorClass () {
      if (this.enable) {
        return 'indicator-enable'
      } else {
        if (this.na) {
          return 'indicator-na'
        }
        return 'indicator-disable'
      }
    },
    indicatorText () {
      if (this.enable) {
        return this.textForEnable
      } else {
        if (this.na) {
          return this.textForNa
        }
        return this.textForDisable
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.indicator-container {
    white-space: nowrap;
    .indicator {
        display: inline-block;
        width: 1em;
        height: 1em;
        border-radius: 0.5em;
        margin-bottom: -4px;
        &.indicator-enable, &.green {
            box-shadow: 0 1px 3px #ffffff inset;
            background-color: #bfff22;
            border: 1px solid #00af00;
        }
        &.indicator-disable, &.red {
            box-shadow: 0 1px 3px #ffaaaa inset;
            background-color: #dd4b4b;
            border: 1px solid #a40000;
        }
        &.indicator-na, &.gray {
            box-shadow: 0 1px 3px #ffffff inset;
            background-color: #aaaaaa;
            border: 1px solid #555555;
        }
    }
}
</style>



// WEBPACK FOOTER //
// Indicator.vue?d53f5d7a